module.exports = __webpack_public_path__ + "static/img/swhz_2x.545f157.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/swhz_2x.png
// module id = JUx3
// module chunks = 1